import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Inject per-page TDK into the document head.
 */
export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }
    if (keywords) {
      setMeta("keywords", keywords);
    }
    setMeta("og:title", title, "property");
    setMeta("twitter:title", title);
  }, [title, description, keywords]);
}